import React, { useState, useEffect } from "react";
import { styled } from "@mui/system";
import {
  Grid,
  TextField,
  Autocomplete,
  Box,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { ToggleButton, ToggleButtonGroup, IconButton } from "@mui/material";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import Tooltip from "@mui/material/Tooltip";
import InputAdornment from "@mui/material/InputAdornment";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const FormContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  width: "50%", // Adjust the width as needed
  margin: "auto",
});

const Form = styled("form")({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const PerfBase = ({
  electricPrice,
  setElectricPrice,
  buildingType,
  setBuildingType,
  manfbuildingType,
  setManfbuildingType,
  buildingloadperc,
  setBuildingloadperc,
  AnnualPerfDgrade,
  setAnnualPerfDgrade,
  designedCapacity,
  setDesignedCapacity,
  designedCapacityUnits,
  setDesignedCapacityUnits,
  designedCOP,
  setDesignedCOP,
  currency,
  country,
  setCurrency,
  investment,
  setInvestment,
  fullChillerCode,
  setFullChillerCode,
  eleccosterror,
  investerror,
  chillercaperror,
  setChillerAge,
  setEleccosterror,
  userMaxMonthlyElecKWH,
  setUserMaxMonthlyElecKWH,
  chillersData,
  setInvesterror,
  setChillercaperror,
  modelNumber,
  setModelNumber,
  chillerSerialNum,
  setChillerSerialNum,
  siteName,
  setSiteName,
  customerName,
  setCustomerName,
  evapChecked,
  manfSource,
  setManfSource,
  powerSupply,
  setRefleakservcost,
  refleakservcost,
  setPowerSupply,
  manfData,
  refLeakFreqency10_15,
  setRefLeakFreqency10_15,
  refLeakFreqency15_20,
  setRefLeakFreqency15_20,
  refLeakFreqency20,
  setRefLeakFreqency20,
  evapTdbMinData,
  evapRHMaxData,
  setEvapTdbMinData,
  setEvapRHMaxData,
  evapCondPumpPower,
  evapCondFanPower,
  evapCondOperatingMonths,
  setEvapCondPumpPower,
  setEvapCondFanPower,
  setEvapCondOperatingMonths,
}) => {
  const [alignment, setAlignment] = useState([]);
  const [manfcProfile, setManfcProfile] = useState([]);
  const [evapCondProfile, setEvapCondProfile] = useState([]);
  const [montuelflag, setMontuelflag] = React.useState(false);

  useEffect(() => {
    const chillerInfo = chillersData?.[chillerSerialNum];

    console.log(
      "chillerSerialNum:",
      chillerSerialNum,
      "chiller Location:",
      chillerInfo?.loc,
      "chiller Age:",
      chillerInfo?.age
    );
    if (chillerInfo) {
      setChillerAge(parseInt(chillerInfo?.age));
    }

    if (chillerSerialNum && chillerInfo) {
      if (chillerInfo.loc === "Montluel") {
        setMontuelflag(true);
      } else {
        setMontuelflag(false);
      }
    } else {
      setMontuelflag(false);
    }
  }, [chillerSerialNum, chillersData]);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleChangeManfSource = (event) => {
    console.log("Selected Manufacturing Source:", event.target.value);
    if (!montuelflag) {
      setManfSource("EMEA");
    }

    if (!montuelflag) {
      setManfSource(event.target.value);
      setPowerSupply(manfData[event.target.value]);
    }
  };

  const handleChangePowerSupply = (event) => {
    setPowerSupply(event.target.value);
  };

  const chillerOptions = Object.keys(chillersData || {});

  const handleChange = (e) => {
    const { id, value } = e.target;
    switch (id) {
      case "electricPrice":
        setElectricPrice(value);
        setEleccosterror(false);
        break;
      case "buildingType":
        setBuildingType(value);
        break;
      case "manfbuildingType":
        setManfbuildingType(value);
        break;
      case "fullChillerCode":
        setFullChillerCode(value);
        break;
      case "AnnualPerfDgrade":
        if (!isNaN(value) && value <= 1.0) {
          setAnnualPerfDgrade(value);
        } else {
        }
        break;
      case "buildingloadperc":
        if (!isNaN(value) && value <= 100.0) {
          setBuildingloadperc(value);
        } else {
        }
        break;
      case "designedCOP":
        setDesignedCOP(value);
        break;
      case "modelNumber":
        setModelNumber(value);
        break;
      case "chillerSerialNum":
        setChillerSerialNum(value);
        break;
      case "siteName":
        setSiteName(value);
        break;
      case "customerName":
        setCustomerName(value);
        break;
      case "designedCapacity":
        setDesignedCapacity(value);
        setChillercaperror(false);
        break;
      case "investment":
        setInvestment(value);
        setInvesterror(false);
        break;
      case "evapTdbMinData":
        setEvapTdbMinData(value);
        break;
      case "evapRHMaxData":
        setEvapRHMaxData(value);
        break;
      case "evapCondPumpPower":
        setEvapCondPumpPower(value);
        break;
      case "evapCondFanPower":
        setEvapCondFanPower(value);
        break;
      case "refleakservcost":
        setRefleakservcost(parseFloat(value));
        break;
      case "refLeakFreqency10_15":
        setRefLeakFreqency10_15(parseFloat(value));
        break;
      case "refLeakFreqency15_20":
        setRefLeakFreqency15_20(parseFloat(value));
        break;
      case "refLeakFreqency20":
        setRefLeakFreqency20(parseFloat(value));
        break;
      case "userMaxMonthlyElecKWH":
        setUserMaxMonthlyElecKWH(parseFloat(value));
        break;
      default:
        break;
    }
  };

  const SmallLabel = styled("span")({
    fontSize: "0.85rem", // Adjust the font size as needed
    fontWeight: "bold", // You can adjust other styles here as well
  });

  const handleTypeChange = (event, newAlignment) => {
    if (alignment === newAlignment) {
      setAlignment(null); // Toggle off if the same button is clicked again
    } else {
      setAlignment(newAlignment);
    }
    console.log(alignment);
  };

  const handleManfTypeChange = (event, newManfcProfile) => {
    if (manfcProfile === newManfcProfile) {
      setManfcProfile(null); // Toggle off if the same button is clicked again
    } else {
      setManfcProfile(newManfcProfile);
    }
    console.log(manfcProfile);
  };

  const handleEvapCondChange = (event, newEvapCondProfile) => {
    if (evapCondProfile === newEvapCondProfile) {
      setEvapCondProfile(null); // Toggle off if the same button is clicked again
    } else {
      setEvapCondProfile(newEvapCondProfile);
    }
  };

  const handleBuildingTypeChange = (e) => {
    setBuildingType(e.target.value);
    setManfbuildingType("Commercial (Office / Shopping Mall)");
  };

  const handleManfBuildingTypeChange = (e) => {
    setManfbuildingType(e.target.value);
  };

  const handleDesignedCapacityUnitsChange = (event) => {
    setDesignedCapacityUnits(event.target.value);
  };

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
  };

  const buildingTypeOptions = [
    "Commercial (Office / Shopping Mall)",
    "Retail",
    "Residential",
    "Manufacturing",
    "Hotels",
    "Hospitals",
    "Schools / Universities",
  ];

  const ManfacturingTypeOptions = [
    "Commercial (Office / Shopping Mall)",
    "Retail",
    "Residential",
    "Hotels",
    "Hospitals",
    "Schools / Universities",
  ];

  const currencySymbols = {
    SAR: "﷼", // Saudi Riyal (SAR)
    AED: "د.إ", // UAE Dirham (AED)
    KWD: "د.ك", // Kuwaiti Dinar (KWD)
    QAR: "ر.ق", // Qatari Riyal (QAR)
    GBP: "£", // British Pound (GBP)
    EUR: "€", // Euro (EUR)
  };

  const handleClear = () => {
    setElectricPrice("");
    setBuildingType("");
    setManfbuildingType("");
    setAnnualPerfDgrade("1.00");
    setDesignedCapacity("");
    setDesignedCOP("");
    setFullChillerCode("");
    setInvestment("");
    setUserMaxMonthlyElecKWH("");
  };

  const handleMonthChange = (event, selectedOptions) => {
    setEvapCondOperatingMonths(selectedOptions);
    // console.log("selectedOptions", selectedOptions)
  };

  return (
    <div>
      {/* <Button style={{ padding: 0, float: "right" }} onClick={handleClear}>Clear</Button> */}
      <FormContainer style={{ paddingTop: "0rem", width: "80%" }}>
        {/* <Typography variant="h4">Performance Base</Typography> */}
        <Form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Tooltip
              title={
                <React.Fragment>
                  <div>Building application type as Mall, School, etc.</div>
                </React.Fragment>
              }
              placement="bottom-end"
              arrow
            >
              <Grid style={{}} item xs={3} sm={6}>
                <TextField
                  id="buildingType"
                  label={<SmallLabel>Building Type</SmallLabel>}
                  variant="outlined"
                  fullWidth
                  select
                  value={buildingType}
                  onChange={handleBuildingTypeChange}
                >
                  {buildingTypeOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      <SmallLabel>{option}</SmallLabel>
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Tooltip>

            <Tooltip
              title={
                <React.Fragment>
                  <div>Designed full load cooling capacity (KW)</div>
                </React.Fragment>
              }
              placement="bottom-end"
              arrow
            >
              <Grid item xs={16} sm={4}>
                <TextField
                  id="designedCapacity"
                  label={<SmallLabel>Designed Chiller Capacity</SmallLabel>}
                  variant="outlined"
                  fullWidth
                  type="number"
                  inputProps={{ min: 0 }}
                  value={designedCapacity}
                  onChange={handleChange}
                  error={chillercaperror}
                  helperText={
                    chillercaperror
                      ? "Please enter the Designed Chiller Capacity."
                      : ""
                  }
                />
              </Grid>
            </Tooltip>

            <Grid style={{ paddingLeft: 0 }} item xs={16} sm={2}>
              <TextField
                id="designedCapacityUnits"
                // label={<SmallLabel>Units</SmallLabel>}
                variant="outlined"
                fullWidth
                select
                type="number"
                inputProps={{ min: 0 }}
                value={designedCapacityUnits}
                onChange={handleDesignedCapacityUnitsChange}
                required
              >
                <MenuItem value={"kW"}>
                  <SmallLabel>kW</SmallLabel>
                </MenuItem>
                <MenuItem value={"RT"}>
                  <SmallLabel>tons (RT)</SmallLabel>
                </MenuItem>
              </TextField>
            </Grid>

            <Tooltip
              title={
                <React.Fragment>
                  <div>Electricity price ( local price/kWh)</div>
                </React.Fragment>
              }
              placement="bottom-end"
              arrow
            >
              <Grid item xs={16} sm={3}>
                <TextField
                  id="electricPrice"
                  label={<SmallLabel>Energy Tariff (cost per kWh)</SmallLabel>}
                  variant="outlined"
                  fullWidth
                  type="number"
                  inputProps={{ min: 0 }}
                  value={electricPrice}
                  onChange={handleChange}
                  error={eleccosterror}
                  helperText={
                    eleccosterror ? "Please enter the Electrical cost." : ""
                  }
                  required
                />
              </Grid>
            </Tooltip>

            <Tooltip
              title={
                <React.Fragment>
                  <div>Cost of Replacing Condenser</div>
                </React.Fragment>
              }
              placement="bottom-end"
              arrow
            >
              <Grid item xs={16} sm={3}>
                <TextField
                  id="investment"
                  label={
                    <SmallLabel>Cost of Replacement (Investment)</SmallLabel>
                  }
                  variant="outlined"
                  fullWidth
                  type="number"
                  inputProps={{ min: 0 }}
                  value={investment}
                  onChange={handleChange}
                  error={investerror}
                  helperText={investerror ? "Please enter Investment." : ""}
                />
              </Grid>
            </Tooltip>

            <Grid style={{ paddingLeft: 0 }} item xs={16} sm={2}>
              <TextField
                id="currency"
                label={<SmallLabel>Currency</SmallLabel>}
                variant="outlined"
                fullWidth
                select
                type="number"
                inputProps={{ min: 0 }}
                value={currency}
                onChange={handleCurrencyChange}
                required
              >
                <MenuItem value={"KWD"}>
                  <SmallLabel>KWD</SmallLabel>
                </MenuItem>
                <MenuItem value={"AED"}>
                  <SmallLabel>AED</SmallLabel>
                </MenuItem>
                <MenuItem value={"QAR"}>
                  <SmallLabel>QAR</SmallLabel>
                </MenuItem>
                <MenuItem value={"SAR"}>
                  <SmallLabel>SAR</SmallLabel>
                </MenuItem>
                <MenuItem value={"GBP"}>
                  <SmallLabel>GBP</SmallLabel>
                </MenuItem>
                <MenuItem value={"EUR"}>
                  <SmallLabel>EUR</SmallLabel>
                </MenuItem>
              </TextField>
            </Grid>

            {/* Refrigerant leakage changes addition */}
            <Grid item xs={3} sm={3}>
              {
                <Tooltip
                  title={
                    <React.Fragment>
                      <div>Service Cost</div>
                    </React.Fragment>
                  }
                  placement="bottom-end"
                  arrow
                >
                  <TextField
                    id="refleakservcost"
                    label={
                      <SmallLabel>Refrigerant leakage Service Cost</SmallLabel>
                    }
                    variant="outlined"
                    fullWidth
                    type="number"
                    inputProps={{ min: 0 }}
                    value={refleakservcost}
                    onChange={handleChange} // Use handleInputChange for input validation
                    // InputProps={{
                    //   endAdornment: (
                    //     <InputAdornment position="end">
                    //       {currency}
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                </Tooltip>
              }
            </Grid>
            <Grid item xs={3} sm={2.7}>
              {
                <Tooltip
                  title={
                    <React.Fragment>
                      <div>Chiller age `less than 10 years`</div>
                    </React.Fragment>
                  }
                  placement="bottom-end"
                  arrow
                >
                  <TextField
                    id="refLeakFreqency10_15"
                    label={
                      <SmallLabel>
                        Leakage frequency (Age btw 10-15 yrs)
                      </SmallLabel>
                    }
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={refLeakFreqency10_15}
                    onChange={handleChange} // Use handleInputChange for input validation
                    InputProps={{
                      endAdornment: "Months", // Add percentage symbol as the input's end adornment
                    }}
                  />
                </Tooltip>
              }
            </Grid>

            <Grid item xs={3} sm={2.7}>
              {
                <Tooltip
                  title={
                    <React.Fragment>
                      <div>Chiller age `15–20 years`</div>
                    </React.Fragment>
                  }
                  placement="bottom-end"
                  arrow
                >
                  <TextField
                    id="refLeakFreqency15_20"
                    label={
                      <SmallLabel>
                        Leakage frequency (Age btw 15-20 yrs)
                      </SmallLabel>
                    }
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={refLeakFreqency15_20}
                    onChange={handleChange} // Use handleInputChange for input validation
                    InputProps={{
                      endAdornment: "Months", // Add percentage symbol as the input's end adornment
                    }}
                  />
                </Tooltip>
              }
            </Grid>

            <Grid item xs={3} sm={2.7}>
              {
                <Tooltip
                  title={
                    <React.Fragment>
                      <div>Chiller age `above 20 years`</div>
                    </React.Fragment>
                  }
                  placement="bottom-end"
                  arrow
                >
                  <TextField
                    id="refLeakFreqency20"
                    label={
                      <SmallLabel>
                        Leakage frequency (Age above 20 yrs)
                      </SmallLabel>
                    }
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={refLeakFreqency20}
                    onChange={handleChange} // Use handleInputChange for input validation
                    InputProps={{
                      endAdornment: "Months", // Add percentage symbol as the input's end adornment
                    }}
                  />
                </Tooltip>
              }
            </Grid>

            <Grid item xs={3} sm={3}>
              {!evapChecked && (
                <Tooltip
                  title={
                    <React.Fragment>
                      <div>• 0.25% per year - Good maintenance</div>
                      <div>• 0.50% per year - Average maintenance</div>
                      <div>• 0.75% per year - Below average maintenance</div>
                      <div>• 1.00% per year - Bad maintenance</div>
                    </React.Fragment>
                  }
                  placement="bottom-end"
                  arrow
                >
                  <TextField
                    id="AnnualPerfDgrade"
                    label={
                      <SmallLabel>
                        Annual Performance Downgrading Factor % (Max
                        Downgrading)
                      </SmallLabel>
                    }
                    variant="outlined"
                    fullWidth
                    type="number"
                    inputProps={{ min: 0 }}
                    value={AnnualPerfDgrade}
                    onChange={handleChange} // Use handleInputChange for input validation
                    InputProps={{
                      endAdornment: "%", // Add percentage symbol as the input's end adornment
                    }}
                  />
                </Tooltip>
              )}
            </Grid>
          </Grid>

          <Grid container spacing={1} width={"50%"}>
            <Grid item xs={10} sm={3}>
              <ToggleButtonGroup
                color="primary"
                value={alignment}
                exclusive={false}
                size="small"
                onChange={handleTypeChange}
                aria-label="Platform"
              >
                <ToggleButton
                  style={{
                    color: "#1976d2",
                    padding: 0,
                    paddingLeft: "10px",
                    width: "10rem",
                  }}
                  value="Advanced"
                >
                  {
                    <SmallLabel>
                      Advanced
                      <IconButton edge="end">
                        {alignment.length > 0 ? (
                          <KeyboardDoubleArrowUpIcon color="primary" />
                        ) : (
                          <KeyboardDoubleArrowDownIcon color="primary" />
                        )}
                      </IconButton>{" "}
                    </SmallLabel>
                  }
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            {buildingType === "Manufacturing" && (
              <Grid item xs={10} sm={5}>
                <ToggleButtonGroup
                  color="primary"
                  value={manfcProfile}
                  exclusive={false}
                  size="small"
                  onChange={handleManfTypeChange}
                  aria-label="Platform"
                >
                  <ToggleButton
                    style={{
                      color: "#1976d2",
                      padding: 0,
                      marginLeft: "3rem",
                      paddingLeft: "10px",
                      width: "15rem",
                    }}
                    value="manf_profile"
                  >
                    {
                      <SmallLabel>
                        Manufacturing Profile
                        <IconButton edge="end">
                          {manfcProfile.length > 0 ? (
                            <KeyboardDoubleArrowUpIcon color="primary" />
                          ) : (
                            <KeyboardDoubleArrowDownIcon color="primary" />
                          )}
                        </IconButton>{" "}
                      </SmallLabel>
                    }
                  </ToggleButton>
                </ToggleButtonGroup>
              </Grid>
            )}
            {evapChecked && (
              <Grid item xs={10} sm={4}>
                <ToggleButtonGroup
                  color="primary"
                  value={evapCondProfile}
                  exclusive={false}
                  size="small"
                  onChange={handleEvapCondChange}
                  aria-label="Platform"
                >
                  <ToggleButton
                    style={{
                      color: "#1976d2",
                      padding: 0,
                      marginLeft: "6rem",
                      paddingLeft: "10px",
                      width: "15rem",
                    }}
                    value="evap cond"
                  >
                    {
                      <SmallLabel>
                        Evap. Cond. Params
                        <IconButton edge="end">
                          {evapCondProfile.length > 0 ? (
                            <KeyboardDoubleArrowUpIcon color="primary" />
                          ) : (
                            <KeyboardDoubleArrowDownIcon color="primary" />
                          )}
                        </IconButton>{" "}
                      </SmallLabel>
                    }
                  </ToggleButton>
                </ToggleButtonGroup>
              </Grid>
            )}
          </Grid>

          {alignment.length > 0 ? (
            <>
              <Grid container spacing={2}>
                <Grid item xs={16} sm={6}>
                  <TextField
                    id="modelNumber"
                    label={<SmallLabel>Model Number</SmallLabel>}
                    variant="outlined"
                    fullWidth
                    value={modelNumber}
                    onChange={handleChange}
                  />
                </Grid>

                <Tooltip
                  title={
                    <React.Fragment>
                      <div>Chiller serial number in Carrier Network</div>
                    </React.Fragment>
                  }
                  placement="bottom-end"
                  arrow
                >
                  <Grid item xs={16} sm={6}>
                    <FormControl fullWidth>
                      <Autocomplete
                        freeSolo
                        options={chillerOptions}
                        value={chillerSerialNum}
                        onInputChange={(event, newInputValue) => {
                          setChillerSerialNum(newInputValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              <SmallLabel>Chiller Serial Number</SmallLabel>
                            }
                            variant="outlined"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                </Tooltip>

                <Tooltip
                  title={
                    <React.Fragment>
                      <div>Name of chiller plant site</div>
                    </React.Fragment>
                  }
                  placement="bottom-end"
                  arrow
                >
                  <Grid item xs={16} sm={4}>
                    <TextField
                      id="siteName"
                      label={<SmallLabel>Site Name</SmallLabel>}
                      variant="outlined"
                      fullWidth
                      value={siteName}
                      onChange={handleChange}
                    />
                  </Grid>
                </Tooltip>

                <Tooltip
                  title={
                    <React.Fragment>
                      <div>
                        Name of customer who owns the chiller plant site
                      </div>
                    </React.Fragment>
                  }
                  placement="bottom-end"
                  arrow
                >
                  <Grid item xs={16} sm={4}>
                    <TextField
                      id="customerName"
                      label={<SmallLabel>Customer Name</SmallLabel>}
                      variant="outlined"
                      fullWidth
                      value={customerName}
                      onChange={handleChange}
                    />
                  </Grid>
                </Tooltip>

                <Tooltip
                  title={
                    <React.Fragment>
                      <div>Max monthly electricity consumption (kWh)</div>
                    </React.Fragment>
                  }
                  placement="bottom-end"
                  arrow
                >
                  <Grid item xs={16} sm={4}>
                    <TextField
                      id="userMaxMonthlyElecKWH"
                      label={
                        <SmallLabel>Max monthly electricity consumption (kWh)</SmallLabel>
                      }
                      variant="outlined"
                      fullWidth
                      type="number"
                      inputProps={{ min: 0 }}
                      value={userMaxMonthlyElecKWH}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                </Tooltip>

                <Grid item xs={16} sm={6}>
                  <div>
                    <Autocomplete
                      sx={{
                        border: "1.5px solid #ccc", // Add a border
                        borderRadius: "2px", // Optional: Add border radius for rounded corners
                      }}
                      multiple
                      size="small"
                      limitTags={7}
                      id="combo-box-demo"
                      options={[...months]} // Add 'Select All' option
                      disableCloseOnSelect
                      getOptionLabel={(option) => option}
                      value={evapCondOperatingMonths}
                      onChange={handleMonthChange}
                      isOptionEqualToValue={(option, value) =>
                        option === value || value === ""
                      }
                      renderInput={(params) => (
                        <TextField
                          style={{ padding: "2px" }}
                          {...params}
                          variant="standard"
                          label={
                            <SmallLabel style={{ paddingLeft: "1rem" }}>
                              Operating Months
                            </SmallLabel>
                          }
                          placeholder="Months"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                          }}
                        />
                      )}
                    />
                  </div>
                </Grid>

                <Grid item xs={16} sm={3}>
                  <TextField
                    id="manfSource"
                    label={<SmallLabel>Manufacturing</SmallLabel>}
                    variant="outlined"
                    fullWidth
                    select
                    value={montuelflag ? "EMEA" : manfSource}
                    onChange={handleChangeManfSource}
                    disabled={montuelflag}
                  >
                    {Object.keys(manfData).map((manf) => (
                      <MenuItem key={manf} value={manf}>
                        <SmallLabel>{manf}</SmallLabel>
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={16} sm={3}>
                  <TextField
                    id="powersupply"
                    label={<SmallLabel>Power Supply</SmallLabel>}
                    variant="outlined"
                    fullWidth
                    select
                    value={powerSupply}
                    onChange={handleChangePowerSupply}
                  >
                    {["50Hz", "60Hz"].map((unit) => (
                      <MenuItem key={unit} value={unit}>
                        <SmallLabel>{unit}</SmallLabel>
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* <Grid item xs={16} sm={6}>
                                    <TextField
                                        id="designedCOP"
                                        label={<SmallLabel>Designed COP</SmallLabel>}
                                        variant="outlined"
                                        fullWidth

                                        type="number"
                                        inputProps={{ min: 0 }}
                                        value={designedCOP}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={16} sm={6}>
                                    <TextField
                                        id="fullChillerCode"
                                        label={<SmallLabel>Full Chiller Code</SmallLabel>}
                                        variant="outlined"
                                        fullWidth

                                        value={fullChillerCode}
                                        onChange={handleChange}
                                    />
                                </Grid> */}
              </Grid>
            </>
          ) : (
            <div></div>
          )}

          {buildingType === "Manufacturing" && manfcProfile.length > 0 ? (
            <>
              <Grid container spacing={2} width={"70%"}>
                <Grid item xs={16} sm={6}>
                  <TextField
                    id="manfbuildingType"
                    label={<SmallLabel>Building Type</SmallLabel>}
                    variant="outlined"
                    fullWidth
                    select
                    value={manfbuildingType}
                    onChange={handleManfBuildingTypeChange}
                  >
                    {ManfacturingTypeOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        <SmallLabel>{option}</SmallLabel>
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={16} sm={3}>
                  <TextField
                    id="buildingloadperc"
                    label={<SmallLabel>Manufacturing Load</SmallLabel>}
                    variant="outlined"
                    fullWidth
                    type="number"
                    inputProps={{ min: 0 }}
                    value={buildingloadperc}
                    onChange={handleChange} // Use handleInputChange for input validation
                    InputProps={{
                      endAdornment: "%", // Add percentage symbol as the input's end adornment
                    }}
                  />
                </Grid>
              </Grid>
            </>
          ) : (
            <div></div>
          )}

          {evapChecked && evapCondProfile.length > 0 ? (
            <>
              <Grid container spacing={2} width={"100%"}>
                <Grid item xs={16} sm={2}>
                  <TextField
                    id="evap_tdb_min_data"
                    label={
                      <SmallLabel>
                        Min OAT for Evap Cond Operation (°C)
                      </SmallLabel>
                    }
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={evapTdbMinData}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={16} sm={2}>
                  <TextField
                    id="evap_rh_max_data"
                    label={
                      <SmallLabel>
                        Max RH for Evap Cond Operation (%)
                      </SmallLabel>
                    }
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={evapRHMaxData}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
              {/* Second Row */}
              <Grid container spacing={2} width={"100%"}>
                <Grid item xs={16} sm={2}>
                  <TextField
                    id="evapCondPumpPower"
                    label={<SmallLabel>Additional Pump Power (W)</SmallLabel>}
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={evapCondPumpPower}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={16} sm={2}>
                  <TextField
                    id="evapCondFanPower"
                    label={<SmallLabel>Additional Fan Power (W)</SmallLabel>}
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={evapCondFanPower}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </>
          ) : (
            <div></div>
          )}
        </Form>
      </FormContainer>
    </div>
  );
};

export default PerfBase;
